<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	firstColumnProperty="device.serialNumber"
	[rowId]="rowId"
>
	@if (!hideToolbar) {
		<app-data-set-toolbar>
			<div *appSearchActionGroup style="flex: 1">
				<app-data-set-search
					defaultFilterName="serialNumber"
					[defaultFilterLabel]="filterLabels.serialNumber"
					[placeholder]="filterLabels.defaultPlaceholder"
				>
					<div class="filter-grid" [style.--columns]="3">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.serialNumber }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('serialNumber')"
									data-automation-id="serial-number-input"
									(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.deviceGroups }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('group')"
									data-automation-id="device-group-input"
									(ngModelChange)="dataSet.filter('group', filterLabels.deviceGroups, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<!-- FIXME: FILTER FIXES -  Should use dropdown -->
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.status }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('displayStatus')"
									data-automation-id="status-input"
									(ngModelChange)="dataSet.filter('displayStatus', filterLabels.status, $event)"
								/>
							</mat-form-field>
						</div>
					</div>
					<div class="filter-grid" [style.--columns]="3">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.propertyName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('propertyName')"
									data-automation-id="property-name-input"
									(ngModelChange)="dataSet.filter('propertyName', filterLabels.propertyName, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.streetAddress }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('streetAddress')"
									data-automation-id="address-input"
									(ngModelChange)="dataSet.filter('streetAddress', filterLabels.streetAddress, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.townCity }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('locality')"
									data-automation-id="city-input"
									(ngModelChange)="dataSet.filter('locality', filterLabels.townCity, $event)"
								/>
							</mat-form-field>
						</div>
					</div>
					<div class="filter-grid" [style.--columns]="3">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.stateProvince }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('stateProvinceRegion')"
									data-automation-id="province-input"
									(ngModelChange)="dataSet.filter('stateProvinceRegion', filterLabels.stateProvince, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.postalCode }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('postalCode')"
									data-automation-id="postal-code-input"
									(ngModelChange)="dataSet.filter('postalCode', filterLabels.postalCode, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<!-- FIXME: FILTER FIXES -  Should use country code lookup -->
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.country }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('countryCode')"
									data-automation-id="country-input"
									(ngModelChange)="dataSet.filter('countryCode', filterLabels.country, $event)"
								/>
							</mat-form-field>
						</div>
					</div>
				</app-data-set-search>
			</div>
			<div style="padding-left: 8px; padding-top: 1px">
				<app-data-set-presentation-toggle
					data-automation-id="all-devices-table-toggle"
				></app-data-set-presentation-toggle>
			</div>
		</app-data-set-toolbar>
	}

	<app-data-set-content>
		<app-data-set-table-view [hidePaginator]="hideToolbar">
			@if (loadingService.isLoading(getAllDevicesLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getAllDevicesLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@all-devicesSerialNumber2">Serial Number</th>
					<td mat-cell *matCellDef="let row">{{ row.device.serialNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="propertyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@all-devicesPropertyName2">Property Name</th>
					<td mat-cell *matCellDef="let row">
						{{ row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="deviceLocation">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@all-devicesDeviceLocation">Device Location</th>
					<td mat-cell *matCellDef="let row">
						{{ row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="group">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@all-devicesGroup(s)">Group(s)</th>
					<td mat-cell *matCellDef="let row">
						<app-overflow-chip-list [chips]="row.groupNames"></app-overflow-chip-list>
					</td>
				</ng-container>

				<ng-container matColumnDef="displayStatus">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@all-devicesStatus">Status</th>
					<td mat-cell *matCellDef="let row" class="status-cell">
						<app-device-status
							[device]="row.device"
							[installation]="row.device.activeDeviceAssignment?.activeInstallation"
						></app-device-status>
					</td>
				</ng-container>

				<ng-container matColumnDef="source">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@all-devices-source">Source</th>
					<td mat-cell *matCellDef="let element">
						<div class="source-container row-left spacing-8">
							@if (isOwnedDeviceGroup(element.source)) {
								<mat-icon class="icon-device-group-owned" svgIcon="sl-device-group-owned"></mat-icon>
							} @else {
								@if (element?.source?.companyName) {
									<mat-icon class="icon-device-group-inherited" svgIcon="sl-device-group-inherited"></mat-icon>
								}
							}
							{{ element?.source?.companyName }}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (canShowDeviceRowMenu(row)) {
							<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(click)="onRowClick(row)"
					[attr.data-automation-id]="'all-devices-row-' + row.id"
				></tr>
			</table>

			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					@if (!row.device.activeDeviceAssignment?.activeInstallation?.utcRemovalRequested) {
						<button
							mat-menu-item
							data-automation-id="ready-for-removal-button"
							(click)="onRowMenuReadyRemovalClicked(row)"
							i18n="@@allDevices-ReadyRemoval"
						>
							Ready for Removal
						</button>
					}
					@if (!!row.device.activeDeviceAssignment?.activeInstallation?.utcRemovalRequested) {
						<button
							mat-menu-item
							data-automation-id="clear-removal-status-button"
							(click)="onRowMenuClearRemovalClicked(row)"
							i18n="@@allDevices-ClearRemoval"
						>
							Clear Removal Status
						</button>
					}
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>

	@if (!isUnitTesting) {
		<app-data-set-map-view [markersInfo]="markersInfo"></app-data-set-map-view>
	}
</app-data-set>
